import { ReactElement } from "react";
import { Navigate } from "react-router-dom";

import NotFound from "../components/global/NotFound";
import * as Pages from "../pages";
import { UserRole } from "../services/api/AuthUser";

type RouteConfig = {
  path: string;
  component: ReactElement;
  navigationItem?: {
    label: string;
  };
  auth?: {
    requiredRoles: UserRole[];
    unauthorizedFallbackOverride?: ReactElement;
  };
};

export const RoutesConfig: RouteConfig[] = [
  {
    path: "/",
    component: <Navigate to="/jobs" />,
  },
  {
    path: "/jobs",
    component: <Pages.Jobs />,
    navigationItem: {
      label: "Jobs",
    },
  },
  {
    path: "/jobs/:id",
    component: <Pages.JobDetails />,
  },
  {
    path: "/jobs/create",
    component: <Pages.JobCreate />,
    auth: {
      requiredRoles: [UserRole.ADMIN, UserRole.OPERATOR],
    },
  },
  {
    path: "/jobs/retranscode",
    component: <Pages.JobReTranscode />,
    auth: {
      requiredRoles: [UserRole.ADMIN, UserRole.OPERATOR],
    },
  },
  {
    path: "/templates",
    component: <Pages.Templates />,
    navigationItem: {
      label: "Templates",
    },
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/templates/edit",
    component: <Pages.TemplateEdit />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/templates/create/:name",
    component: <Pages.TemplateCreate />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/templates/upload",
    component: <Pages.TemplateUpload />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/template-sets",
    component: <Pages.TemplateSets />,
    navigationItem: {
      label: "Sets",
    },
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/template-sets/create",
    component: <Pages.TemplateSetCreate />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/template-sets/:id",
    component: <Pages.TemplateSetEdit />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/encoding-profiles/:name",
    component: <Pages.TemplateDetails />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/backfill",
    component: <Pages.Backfill />,
    navigationItem: {
      label: "Backfill",
    },
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/backfill/create",
    component: <Pages.BackfillCreate />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/backfill/:id",
    component: <Pages.BackfillDetails />,
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/users",
    component: <Pages.Users />,
    navigationItem: {
      label: "Users",
    },
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/stats",
    component: <Pages.Stats />,
    navigationItem: {
      label: "Stats",
    },
    auth: {
      requiredRoles: [UserRole.ADMIN],
    },
  },
  {
    path: "/*",
    component: <NotFound />,
  },
];
